export { type MapProps, default as Map } from './Map';
